<template>
  <spec-frame
    property="welcomeWindowSpec"
    label-str="ようこそ画面"
    lastVersion="1.0.0"
    :isSpecFixed="true"
  >
    <div>※ この画面の仕様です</div>
    <!----------------------
     ! 起動操作
     !--------------------->
    <spec-item class-str="operation" label-str="起動操作">
      <li>画面上部メニューの「ヘルプ」を選択</li>
      <li>「ようこそ画面」を選択</li>
    </spec-item>
    <!----------------------
     ! 仕様
     !--------------------->
    <spec-item class-str="spec" label-str="仕様">
      <li>表示文字サイズ調整機能</li>
      <li>
        ログイン処理（ログインタブ）
        <ol>
          <li>
            ログイン情報<br />
            ログインに必要なのは以下の５項目で、事前にURLパラメータに含めておけば画面での入力を省略することが可能<br />
            上記５項目は画面操作で入室すればURLに勝手に付与されるので、入室後に画面再読み込みをすれば同じ部屋、同じプレイヤーでの再入室が自動で行われる
            <ul>
              <li>
                部屋名（roomName）文字列（※1）
              </li>
              <li>
                部屋パスワード（roomPassword）文字列（※1）
              </li>
              <li>
                プレイヤー名（playerName）文字列（※1）
              </li>
              <li>
                プレイヤーパスワード（playerPassword）文字列（※1）
              </li>
              <li>
                プレイヤー権限（playerType）（※2）
              </li>
              <li>
                (※1):空白文字は「%20」で指定すること。URLに空白文字がそのまま入るとそこで途切れてしまう為
              </li>
              <li>
                (※2):以下のいずれかを指定する。誤った場合は指定なしとして扱う。
                <ol>
                  <li>PL：プレイヤーを指す</li>
                  <li>GM：ゲームマスターを指す</li>
                  <li>サブGM</li>
                  <li>見学者</li>
                </ol>
              </li>
            </ul>
          </li>
          <li>
            部屋データから部屋をつくる
            <ol>
              <li>
                保存したQuoridornの部屋データを読み込ませることで、データから部屋を復元し、継続卓ができるようにします。
              </li>
            </ol>
          </li>
          <li>
            部屋を指定して入室する／新しい部屋をつくる
            <ol>
              <li>
                部屋名を入力して「チェック」ボタンを押すことで目的の部屋が存在するかチェックします。
              </li>
              <li>
                「チェック」ボタンを押した結果、部屋が存在した場合
                <ol>
                  <li>部屋パスワードの入力を求めます。</li>
                  <li>
                    部屋パスワードが合っていたらプレイヤー情報を入力してもらい、入室完了です。
                  </li>
                  <li>
                    入力するプレイヤー名は再入室や継続卓を考慮し、入室履歴のあるプレイヤーの名前が選択肢として表示されます。
                  </li>
                </ol>
              </li>
              <li>
                「チェック」ボタンを押した結果、部屋が存在しなかった場合
                <ol>
                  <li>２つの選択肢があります。</li>
                  <li>
                    部屋ができるのを待つ
                    <ol>
                      <li>
                        これを選んだ場合はプレイヤー情報まで入力してもらい、待機部屋に入室してもらいます。
                      </li>
                      <li>
                        この部屋では同様に待機部屋に入室した人と通常の操作を試しながら、目的の部屋ができるまで待機することができます。
                      </li>
                      <li>
                        目的の部屋が作成されたらメッセージが表示され、目的の部屋に移動することになります。
                      </li>
                      <li>
                        ※
                        この部屋で作成されたデータは目的の部屋には引き継がれません。
                      </li>
                    </ol>
                  </li>
                  <li>
                    新しい部屋をつくる
                    <ol>
                      <li>
                        部屋パスワードとプレイヤー情報を入力してもらい、入室となります。
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li>
                「チェック」ボタンを押してから入室までの間に目的の部屋の存在の有無が変わっていた場合は進まず、改めて「チェック」ボタンを押した後の振る舞いとなって、画面が切り替わります。
              </li>
            </ol>
          </li>
          <li>
            部屋をつくらずQuoridornをつかう
            <ol>
              <li>
                卓でつかうデータの作成・保存をするための作業場所です。
              </li>
              <li>
                通常の部屋との違いは通信機能が使えないだけの劣化版です。
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li>仕様の表示（仕様一覧タブ）</li>
      <li>出典元情報の表示（出典元情報タブ）</li>
    </spec-item>
    <!----------------------
     ! ユーザ要望
     !--------------------->
    <spec-item class-str="request" label-str="ユーザ要望">
      <li>なし</li>
    </spec-item>
    <!----------------------
     ! 未実装事項
     !--------------------->
    <spec-item class-str="unImplemented" label-str="未実装事項">
      <li>内容は順次更新</li>
    </spec-item>
    <!----------------------
     ! 実装しない機能
     !--------------------->
    <spec-item class-str="unSupport" label-str="実装しない機能">
      <li>なし</li>
    </spec-item>
    <!----------------------
     ! 関連項目
     !--------------------->
    <spec-item class-str="ref" label-str="関連項目">
      <li>
        <spec-link property="menuBar" title-str="">メインメニュー</spec-link>
      </li>
    </spec-item>
  </spec-frame>
</template>

<script>
import SpecMixin from "./SpecMixin";
export default { mixins: [SpecMixin] };
</script>

<style scoped src="./spec.css"></style>
